<template>
  <div class="mc-widget-call-broadcast__item-wrapper">
    <StateConnecting
      v-if="state === 'connecting'"
      :licensePlate="licensePlate"
      :driver="driver"
      @endBroadcast="removeBroadcastVehicle"
    />
    <StateOnGoing
      v-if="state === 'onGoing'"
      :licensePlate="licensePlate"
      :driver="driver"
      @endBroadcast="removeBroadcastVehicle"
    />
    <StateInOtherCall
      v-if="state === 'inOtherCall'"
      :licensePlate="licensePlate"
      :driver="driver"
      @endBroadcast="removeBroadcastVehicle"
    />
    <StateFailConnect
      v-if="state === 'failConnect'"
      :licensePlate="licensePlate"
      :driver="driver"
      @endBroadcast="removeBroadcastVehicle"
      @reconnectBroadcast="reconnectBroadcast"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StateConnecting from './state/Connecting.vue'
import StateOnGoing from './state/OnGoing.vue'
import StateFailConnect from './state/FailConnect.vue'
import StateInOtherCall from './state/InOtherCall.vue'
import { Helper } from '@/mixin/helper'

export default {
  name: 'BroadcastItem',
  components: {
    StateConnecting,
    StateOnGoing,
    StateFailConnect,
    StateInOtherCall,
  },
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      validator: (value) => typeof value === 'string' || value === null,
      required: true,
    },
    state: {
      type: String, // ENUM: onGoing, connecting, failConnect, inOtherCall
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    imei: {
      type: String,
      required: true,
    },
    muted: {
      type: Boolean,
      required: false,
      default: true,
    },
    audioContext: {
      type: AudioContext,
      required: true,
    },
  },
  data() {
    return {
      voip: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
  },
  async mounted() {
    this.$emit('setCallsValue', this.imei, 'state', 'connecting')
  },
  beforeDestroy() {},
  methods: {
    async reconnectBroadcast() {
      this.$emit('reconnectBroadcast', this.imei)
    },

    removeBroadcastVehicle() {
      this.$emit('removeBroadcastVehicle', this.vehicleId)
    },
  },
}
</script>

<style lang="scss">
.mc-widget-call-broadcast__item-wrapper {
  padding: 16px;
  border-bottom: 1px solid $border-color;
  &:hover {
    background-color: $cyan-100;
    i.icon-fill_close {
      display: block;
    }
    p.mc-widget-call-broadcast__state-title {
      display: block;
    }
  }
  .mc-widget-call-broadcast__licenseplate {
    color: $mep-color-text-400;
    font-weight: 700;
    font-size: 13px;
    margin-bottom: 2px;
  }

  .mc-widget-call-broadcast__driver {
    color: $teal-200;
    font-weight: 500;
    font-size: 11px;
    margin: 0;
  }

  .mc-widget-call-broadcast__state-title {
    font-weight: 400;
    font-size: 13px;
    color: $teal-200;
    margin: 0;
  }

  .mc-widget-call-broadcast__state-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;

    i::before {
      cursor: pointer;
      font-size: 16px;
    }
  }
}
.mc-widget-call-broadcast__state-title-wrapper i.icon-fill_close {
  display: none;
}
</style>
